/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './clinical-dictionary.reducer';

export const ClinicalDictionaryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const clinicalDictionaryEntity = useAppSelector(state => state.clinicalDictionary.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="clinicalDictionaryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.clinicalDictionary.detail.title">ClinicalDictionary</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.id">Id</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.id}</dd>
          <dt>
            <span id="entityid">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.entityid">Entityid</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.entityid}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.entityType}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.name">Name</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.value">Value</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.value}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.createdBy}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.createDate}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.lastUpdated}</dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.lastModifiedBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.active">Active</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionary.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.clinicalDictionary.dictionaryType">Dictionary Type</Translate>
          </dt>
          <dd>{clinicalDictionaryEntity.dictionaryType ? clinicalDictionaryEntity.dictionaryType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.clinicalDictionary.parent">Parent</Translate>
          </dt>
          <dd>{clinicalDictionaryEntity.parent ? clinicalDictionaryEntity.parent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/clinical-dictionary" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/clinical-dictionary/${clinicalDictionaryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ClinicalDictionaryDetail;
